// extracted by mini-css-extract-plugin
module.exports = {"description_row":"NotificationContainer_description_row__1EsMk","notification_container":"NotificationContainer_notification_container__qrX6Q"};